import { format } from 'date-fns';
import { useQuery } from 'react-query';

import { TABLET_API_ORIGIN } from '@/global/env';
import { getClient } from '@/lib/restClient';

export interface CSVJobItem {
  id: string;
  auth_enterprise_id: number;
  status: 'triggered' | 'completed' | 'failed' | 'empty';
  presigned_url: string | null;
  file_created_at: string | null;
  expires_at: string | null;
}

export interface MappedCSVJobItem {
  id: string;
  createdAt: string;
  status: 'triggered' | 'processing' | 'completed' | 'failed' | 'empty';
  statusText:
    | '作成開始'
    | '作成中'
    | '作成完了'
    | '作成失敗'
    | '該当データなし';
  expiryDate: string;
  downloadUrl: string | null;
}

const mapStatusToText = (
  status: 'triggered' | 'processing' | 'completed' | 'failed' | 'empty'
): '作成開始' | '作成中' | '作成完了' | '作成失敗' | '該当データなし' => {
  switch (status) {
    case 'triggered':
      return '作成開始';
    case 'processing':
      return '作成中';
    case 'completed':
      return '作成完了';
    case 'failed':
      return '作成失敗';
    case 'empty':
      return '該当データなし';
  }
};

const formatDate = (dateString: string | null): string => {
  if (!dateString) return '';
  try {
    return format(new Date(dateString), 'yyyy/MM/dd HH:mm');
  } catch {
    return '';
  }
};

export const useListCSVJobs = () => {
  const { data, error, isLoading, refetch } = useQuery<CSVJobItem[], Error>(
    'csv-jobs',
    async (): Promise<CSVJobItem[]> => {
      const restClient = getClient();
      return await restClient.get(
        `${TABLET_API_ORIGIN}/dashboard-api/order-data/csv-jobs` as const
      );
    },
    {
      retry: false,
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const csvJobs: MappedCSVJobItem[] =
    data?.map((job) => ({
      id: job.id,
      createdAt: formatDate(job.file_created_at),
      status: job.status,
      statusText: mapStatusToText(job.status),
      expiryDate: formatDate(job.expires_at),
      downloadUrl: job.status === 'completed' ? job.presigned_url : null,
    })) || [];

  return {
    csvJobs,
    isLoading,
    error,
    refetchCSVJobs: refetch,
  };
};
